<script setup lang="ts">
defineProps<{
  open: boolean;
  /** Ключ текущей страницы для подсветки активного пункта меню */
  current: string;
}>();
const emit = defineEmits<{ (e: 'close'): void }>();

const navLinks = [
  { key: 'home', href: '/', label: 'Главная' },
  { key: 'requirements', href: '/requirements.html', label: 'Документы и требования' },
  { key: 'about', href: '/about.html', label: 'О компании' },
];
</script>

<template>
  <div class="mobile-nav" :class="{ open }">
    <div class="mobile-nav-header">
      <span class="logo-text">Меню</span>
      <button
        class="theme-toggle"
        type="button"
        aria-label="Закрыть меню"
        @click="emit('close')"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="6" y1="6" x2="18" y2="18" />
          <line x1="6" y1="18" x2="18" y2="6" />
        </svg>
      </button>
    </div>
    <a
      v-for="link in navLinks"
      :key="link.key"
      :href="link.href"
      :class="{ 'is-active': link.key === current }"
      :aria-current="link.key === current ? 'page' : undefined"
      @click="emit('close')"
    >
      {{ link.label }}
    </a>
    <a
      href="tel:+375339933338"
      class="mobile-nav__phone"
      style="margin-top: auto; color: var(--color-primary)"
    >
      +375 33 993-33-38
    </a>
  </div>
</template>
